import { render, staticRenderFns } from "./Typing-Test-KrutiDev-Hindi.vue?vue&type=template&id=584d2e7e&"
import script from "./Typing-Test-KrutiDev-Hindi.vue?vue&type=script&lang=js&"
export * from "./Typing-Test-KrutiDev-Hindi.vue?vue&type=script&lang=js&"
import style0 from "./Typing-Test-KrutiDev-Hindi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports